"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bootstrap = void 0;
var _healthCheck = require("./healthCheck");
var GOOGLE_PUBLISHER_URL = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
var getShouldFetchScript = function getShouldFetchScript() {
  var existingScript = global.document.querySelector("script[src=\"".concat(GOOGLE_PUBLISHER_URL, "\"]"));
  return !existingScript;
};
var bootstrap = exports.bootstrap = function bootstrap() {
  return new Promise(function (resolve) {
    var shouldFetchScript = getShouldFetchScript();
    var onLoad = function onLoad() {
      (0, _healthCheck.setIsBootstrapSuccess)(true);
      resolve();
    };
    var onError = function onError() {
      console.log("Error loading ".concat(GOOGLE_PUBLISHER_URL));
      resolve(); // ignore this error and continue to download app
    };
    if (shouldFetchScript) {
      var script = document.createElement('script');
      script.onload = onLoad;
      script.onerror = onError;
      script.src = GOOGLE_PUBLISHER_URL;
      global.document.body.appendChild(script);
    } else {
      onLoad(); // isn't stabled, need to add some attr to script
    }
  });
};